enum ActionTypes {
  MAIN_SET_PAGE = 'ADMIN_BINOME_MAIN_SET_PAGE',
  MAIN_SET_SEARCH = 'ADMIN_BINOME_MAIN_SET_SEARCH',
  MAIN_SET_TAGS = 'ADMIN_BINOME_MAIN_SET_TAGS',
  MAIN_SET_EXPORT_COLUMNS = 'ADMIN_BINOME_MAIN_SET_EXPORT_COLUMNS',
  MAIN_SET_TAKE = 'ADMIN_BINOME_MAIN_SET_TAKE',
  MAIN_SET_ORDER = 'ADMIN_BINOME_MAIN_SET_ORDER',
}

export default ActionTypes;